export default __webpack_public_path__ + "static/media/coach@2x.74c5ef0a.webp";